import { createBrowserRouter, type RouteObject } from 'react-router';
import { RequireAuth, RequireFeature, RequirePerm } from '@/auth/Can';
import { AppShell } from '@/components/layout/AppShell';
import LoginPage from '@/features/auth/LoginPage';
import { NotFoundPage, RouteErrorPage } from '@/features/system/SystemPages';
import { APP_ROUTES } from './registry';

/** Builds the data router from the registry. Every registry route is wrapped in a feature guard, then a permission guard. */
export function buildRoutes(): RouteObject[] {
  return [
    { path: '/login', element: <LoginPage />, errorElement: <RouteErrorPage /> },
    {
      element: <RequireAuth />,
      errorElement: <RouteErrorPage />,
      children: [
        {
          element: <AppShell />,
          children: [
            {
              errorElement: <RouteErrorPage />,
              children: [
                ...APP_ROUTES.map<RouteObject>((r) => {
                  const Page = r.page;
                  const element = (
                    <RequireFeature feature={r.feature}>
                      <RequirePerm anyOf={r.perms}>
                        <Page />
                      </RequirePerm>
                    </RequireFeature>
                  );
                  return r.path === '' ? { index: true, element } : { path: r.path, element };
                }),
                { path: '*', element: <NotFoundPage /> },
              ],
            },
          ],
        },
      ],
    },
  ];
}

export const router = createBrowserRouter(buildRoutes());
